import React, { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";
import { storage } from "../Utils/storageService";
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(storage.getLoginId());

  const signup = (user) => {
    setUser(user);
  };

  return <AuthContext.Provider value={{ user, signup }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};

AuthProvider.propTypes = {
  children: PropTypes.any.isRequired,
};
